var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewDocIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8511 41.7659V83.1235H58.0303H86.2095V73.1517V63.1799L84.7264 61.7779L83.2433 60.3534V69.8881V79.4472H58.0303H32.8173V41.7659V4.08457H58.0303H83.2433V27.589V60.3534L84.7264 61.7779C85.4861 62.4906 86.1535 63.1799 86.2095 63.1799C86.2647 63.1799 86.2095 41.719 86.2095 27.0601V0.407405H58.0303H29.8511V41.7659Z",
    fill: "#F7931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1702 10.6663V12.7997H93.2186H95.7674V36.427V70.2176L96.8777 71.2269C97.5835 71.8603 98.7475 73.1518 98.9043 73.2456C99.1196 73.4101 98.9043 58.203 98.9043 35.8884V9.04938H94.7871H85.1702V10.6663Z",
    fill: "#F7931E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0213 30.6543V39.9136H67.617H69.2128V30.6543V21.3951H67.617H66.0213V30.6543Z",
    fill: "#29ABE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5745 33.7407V39.9136H59.6383H60.7021V33.7407V27.5679H59.6383H58.5745V33.7407V33.7407Z",
    fill: "#29ABE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4255 61.5185V63.3704H59.1064H78.7872V61.5185V59.6667H59.1064H39.4255V61.5185V61.5185Z",
    fill: "#29ABE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8645 79.3204V89.2964H69.2128H42.561V87.4447V82.0358H41.3897H39.4255V89.2964V93H69.2128H99V82.6064V72.2138L97.6866 70.9874C96.9419 70.3393 96.2365 69.6912 96.1189 69.5523C95.9229 69.3898 95.8645 71.3568 95.8645 79.3204Z",
    fill: "#F7931E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4255 72.6296V74.4815H59.1064H78.7872V72.6296V70.7778H59.1064H39.4255V72.6296V72.6296Z",
    fill: "#29ABE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13.4321C25 20.3292 19.5968 25.8642 13 25.8642C6.40315 25.8642 1 20.3292 1 13.4321C1 6.53497 6.40315 1 13 1C19.5968 1 25 6.53497 25 13.4321Z",
    stroke: "#29ABE2",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.28,
    y1: 6,
    x2: 13.28,
    y2: 22.1185,
    stroke: "#F7931E",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 13.5965,
    x2: 21.64,
    y2: 13.5965,
    stroke: "#F7931E",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDocIcon);
export default __webpack_public_path__ + "static/media/NewDocIcon.32de1e9f1ac16a173225ff2acd0f2941.svg";
export { ForwardRef as ReactComponent };